import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { Text, IconButton, List, Card, Title } from 'react-native-paper';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

export default function IconTest() {
  return (
    <ScrollView style={styles.container}>
      <Card style={styles.card}>
        <Card.Content>
          <Title>Icon Test Page</Title>
          
          <Text style={styles.sectionTitle}>Direct MaterialCommunityIcons:</Text>
          <View style={styles.iconRow}>
            <MaterialCommunityIcons name="content-copy" size={24} color="black" />
            <Text>content-copy</Text>
          </View>
          
          <Text style={styles.sectionTitle}>React Native Paper IconButton:</Text>
          <View style={styles.iconRow}>
            <IconButton icon="content-copy" size={24} onPress={() => console.log('Pressed')} />
            <Text>content-copy</Text>
          </View>
          
          <Text style={styles.sectionTitle}>React Native Paper List.Icon:</Text>
          <List.Item
            title="Test Item"
            left={(props) => <List.Icon {...props} icon="content-copy" />}
          />
          
          <Text style={styles.sectionTitle}>Other Common Icons:</Text>
          <View style={styles.iconRow}>
            <IconButton icon="email" size={24} />
            <IconButton icon="settings" size={24} />
            <IconButton icon="account" size={24} />
            <IconButton icon="bell" size={24} />
          </View>
        </Card.Content>
      </Card>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
  card: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 20,
    marginBottom: 10,
  },
  iconRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 5,
    gap: 10,
  },
});